var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-activable',{attrs:{"label":"","small":"","titlePath":"sidebar.fixedAssets.unassigned"},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}})
}
var staticRenderFns = []

export { render, staticRenderFns }